import { ProviderDetailPage } from '../ProviderDetailPage';
import type { ProviderMeta } from '../ProviderDetailPage';

const META: ProviderMeta = {
  slug: 'indriver',
  name: 'InDriver',
  tagline: 'InDriver on-demand delivery integration for flexible fare negotiation',
  colorClass: 'bg-[var(--chart-4)]',
  initial: 'I',
  webhookPath: '/webhooks/delivery/indriver',
  feeNote:
    'InDriver Business operates on a fare-negotiation model. Merchants can set a starting offer; ' +
    'riders counter-offer within configurable bounds. Typical base fares in Nairobi: KES 70–130 ' +
    'plus KES 18–28/km. InDriver Business API access requires a signed Business Agreement. ' +
    'Chekit retains its standard delivery service fee (10% or configured %) on top of any ' +
    'third-party payout.',
};

export const InDriverConfigPage = () => <ProviderDetailPage meta={META} />;
